import { render, staticRenderFns } from "./CopyAvailability.vue?vue&type=template&id=2f52620c"
import script from "./CopyAvailability.vue?vue&type=script&lang=ts"
export * from "./CopyAvailability.vue?vue&type=script&lang=ts"
import style0 from "./CopyAvailability.vue?vue&type=style&index=0&id=2f52620c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports